var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-expand-xl" }, [
    _c("a", { staticClass: "navbar-brand" }, [
      _vm.session && _vm.session.session && _vm.session.session.app
        ? _c("picture", [
            _c("img", {
              attrs: { src: "/media/pulse-new/app-icon.png", alt: "logo" }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "logo-name" }, [
        _vm._v(
          _vm._s(
            _vm.session && _vm.session.session && _vm.session.session.app
              ? _vm.session.session.app.name
              : ""
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("button", {
      staticClass: "navbar-toggler",
      class: { open: _vm.expanded },
      attrs: { type: "button" },
      on: { click: _vm.toggle }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse navbar-collapse",
        class: { show: _vm.expanded }
      },
      [
        _c("a", { attrs: { href: "/policies/terms-of-service/" } }, [
          _vm._v("Terms of Services")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/policies/privacy-policy/" } }, [
          _vm._v("Privacy policy")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/policies/subscription-policy/" } }, [
          _vm._v("Subscription Terms")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/policies/money-back-policy/" } }, [
          _vm._v("Money Back policy")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/policies/cookie-policy/" } }, [
          _vm._v("Cookie policy")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "show-contact-form", attrs: { href: "#support" } },
          [_vm._v("Contact us")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { display: "none" },
            attrs: { id: "cancelSubscription", href: "#cancel-subscription" }
          },
          [_vm._v("Cancel Subscription")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }